// extracted by mini-css-extract-plugin
export default {"givingBack":"GivingBackContainer-module_givingBack__q0Lfs"};